export default __webpack_public_path__ + "static/media/bg_ballons2.6785334d.png";